import { makeEnvironmentProviders } from '@angular/core';
import { DirtyStateService } from '@mri-platform/shared/core';
import { provideState } from '@ngrx/store';
import * as fromNavigation from './reducers';
import { DefaultDirtyStateService } from './services/default-dirty-state.service';

export function provideNavigationState() {
  return makeEnvironmentProviders([
    provideState(fromNavigation.navigationFeatureKey, fromNavigation.reducer),
    { provide: DirtyStateService, useClass: DefaultDirtyStateService }
  ]);
}
